<template>
  <div class="questionnaireDivider mt-[24px] mb-[16px]" />
  <div class="flex flex-col">
    <div class="heightContainer">
      <div class="subTitle">
        Height
      </div>
      <el-input
        v-model="this.feetInput"
        @blur="handleHeightChange"
        :disabled="this.isCompleted"
      />
      <div class="unitPart feetUnit">
        ft
      </div>
      <el-input
        v-model="this.inchesInput"
        class="heightInput"
        @blur="handleHeightChange"
        :disabled="this.isCompleted"
      />
      <div class="unitPart">
        inches
      </div>
    </div>
    <div class="weightContainer">
      <div class="subTitle">
        Weight
      </div>
      <el-input
        v-model="this.weightInput"
        class="weightInput"
        @blur="handleWeightChange"
        :disabled="this.isCompleted"
      />
      <div class="unitPart">
        pounds
      </div>
    </div>
  </div>
  <div class="questionnaireDivider mb-[16px]" />
</template>

<script>
import { useQuestionnaireStore } from "@/stores/QuestionnaireStore.ts";
import { mapActions, mapState } from 'pinia';
import { debounce } from 'lodash';

export default {
  name: 'HeightAndWeightFields',
  data() {
    return {
      feetInput: '',
      inchesInput: '',
      weightInput: '',
    };
  },
  watch: {
    weight: {
      immediate: true,
      handler(newValue) {
        if (newValue == 0 || newValue == null || newValue == '') {
          this.weightInput = '';
          return;
        } else {
          this.weightInput = newValue;
        }
      },
    },
    height: {
      immediate: true,
      handler(newValue) {
        if (newValue == 0 || newValue == null || newValue == '') {
          this.feetInput = '';
          this.inchesInput = '';
          return;
        } else {
          this.feetInput = Math.floor(newValue / 12);
          this.inchesInput = newValue % 12;
        }
      },
    },
    feetInput(val) {
      this.feetInput = this.toInteger(val);
    },
    inchesInput(val) {
      this.inchesInput = this.toInteger(val);
    },
    weightInput(val) {
      this.weightInput = this.toInteger(val);
    },
  },
  created() {
    this.handleHeightChange = debounce(this.handleHeightChange, 1000);
    this.handleWeightChange = debounce(this.handleWeightChange, 1000);
  },
  computed: {
    ...mapState(()=>useQuestionnaireStore(), [
      'questionnaireData',
      'height',
      'weight',
      'isCompleted',
    ]),
  },
  methods: {
    ...mapActions(()=>useQuestionnaireStore(), ['setHeight', 'setWeight']),
    toInteger(val) {
      const num = parseInt(val);
      return isNaN(num) || num < 0 ? '' : num;
    },
    handleHeightChange() {
      let height = Number(this.feetInput * 12) + Number(this.inchesInput);
      if (height == 0 || height == null || height == '') {
        this.setHeight('');
        return;
      }
      this.setHeight(height);
    },
    handleWeightChange() {
      if (this.weightInput == null || this.weightInput == 0 || this.weightInput == '') {
        this.setWeight('');
        return;
      }
      this.setWeight(Number(this.weightInput));
    },
  },
};
</script>

<style scoped>
.required {
  color: #ff1d00;
}

.heightContainer,
.weightContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;
}

.subTitle {
  width: 10vw;
  min-width: 100px;
  font-weight: 600;
}

:deep(.el-input__inner) {
  color: #000000 !important;
}
.el-input {
  height: 42px;
  font-family: Roboto;
  width: 16vw;
  max-width: 180px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.3px;
}
:deep(.el-input.is-disabled .el-input__inner) {
  color: #c0c4cc !important;
}
:deep(.el-input__wrapper) {
  box-shadow: none;
  border: 1px solid #bcccdc;
  padding-left: 21px;
}

.unitPart {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.175px;
  margin-left: 10px;
  max-width: 70px;
  width: 5vw;
}

.questionnaireDivider {
  margin: 16px 0;
}

@media only screen and (max-width: 1024px) {
  .unitPart,
  .subTitle {
    font-size: 14px;
  }
  .unitPart {
    margin-left: 5px;
  }
  .el-input {
    font-size: 12px;
  }
  .subTitle {
    width: 10vw;
    min-width: 60px;
  }
  .feetUnit {
    width: 5vw;
  }
  .heightInput.el-input {
    width: 28vw;
    max-width: 767px;
  }
  .weightInput.el-input {
    width: 61.5vw;
    max-width: 767px;
  }
  .questionnaireDivider {
    margin: 12px 0;
  }
}
</style>